:host {
  display: block;
  font-family: var(--ls-font-family);
  width: 150px;
  height: 96px;
  position: absolute;
}

.label{
  font-size: var(--ls-text-base);
  line-height: var(--ls-line-base);
}

.backdrop, .indicator{
  font-family: "Digital";
  font-size: 5rem;
  line-height: 80px;
  width: 75px;
  letter-spacing: 0.05rem;
  position: absolute;
  bottom: 0;
  color: var(--ls-primary-color);
}

.backdrop{
  opacity: 0.1;
}

.indicator {
  text-align: right;
  left: 0;
}
